/* Bounded Phase 1 trial. Load after the selected hero and ingredient-mix setup. */
window.initHencePhase1Hero = function initHencePhase1Hero(root) {
 if (!root || root.dataset.heroInitialized) return () => {};
 const controller = new AbortController();
 root.dataset.heroInitialized = 'true';
 const stage = root.querySelector('.hero-study-stage');
 const products = stage?.querySelector('.hero-study-products');
 const splash = products?.querySelector('.hero-splash-backdrop');
 if (!splash) return () => {};
 root.dataset.phase1Hero = 'trial';
 // Owner-requested punctuation trial; keep the existing material span and mark.
 const headline = stage.querySelector('.opening-copy h1');
 if (headline?.firstChild?.nodeType === Node.TEXT_NODE) headline.firstChild.nodeValue = 'Ready. Set. ';
 const greens = headline?.querySelector('mark .liquid-heading');
 if (greens) greens.textContent = 'Greens.';
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const mobile = matchMedia('(max-width: 760px)');
 const smooth = (a, b, p) => { const t = Math.max(0, Math.min(1, (p - a) / (b - a))); return t * t * (3 - 2 * t); };
 // Verbatim selected-copy.json identity/form/pairing facts, not efficacy claims.
 const rounds = [
  [['Matcha green tea', '1,666.67 mg', 'Finely milled green tea for your daily mix.', 975, 475], ['Lion’s mane', '1,000 mg', 'An edible mushroom in every daily scoop.', 290, 835]],
  [['Ashwagandha KSM‑66', '166.67 mg', 'A root-only extract from KSM‑66.', 1120, 300], ['Spirulina', '2,426.67 mg', 'Blue-green algae. Our largest ingredient by weight.', 250, 1000]]
 ].map(items => {
  const round = document.createElement('ul');
  round.className = 'phase1-ingredient-round';
  round.setAttribute('aria-hidden', 'true');
  const lines = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  lines.classList.add('phase1-leaders'); round.append(lines);
  const labels = items.map(([name, amount, copy]) => {
   const item = document.createElement('li');
   const title = document.createElement('strong'); title.textContent = name;
   const fact = document.createElement('p'); fact.textContent = copy;
   const dose = document.createElement('span'); dose.textContent = amount + ' per 10g serving';
   item.append(title, fact, dose); round.append(item); return item;
  });
  products.append(round); return {element:round, items, labels, lines};
 });
 const positionCallouts = () => {
  const box = products.getBoundingClientRect(), art = splash.getBoundingClientRect();
  if (!box.width || !box.height || !art.height) return;
  // On narrow desktop/tablet layouts, reserve the two label columns plus a
  // small clear gap. The source footprint at +45deg is about 1.3 square sizes.
  const labelWidth = Math.max(...rounds.flatMap(round => round.labels.map(label => label.offsetWidth)));
  const available = Math.max(0, box.width - labelWidth * 2 - 32) / 1.3;
  const size = mobile.matches ? art.height * .875 : Math.min(art.height * .98, available);
  splash.style.setProperty('--phase1-art-size', `${size}px`);
  const cx = art.left - box.left + art.width / 2, cy = art.top - box.top + art.height / 2;
  stage.style.setProperty('--phase1-copy-height', `${stage.querySelector('.opening-copy').offsetHeight}px`);
  rounds.forEach(({items, labels, lines}, roundIndex) => {
   lines.setAttribute('viewBox', `0 0 ${box.width} ${box.height}`);
   lines.innerHTML = items.map((entry, i) => {
    const sx = (entry[3] / 1254 - .5) * size, sy = (entry[4] / 1254 - .5) * size;
    const x = cx + (sx - sy) / Math.SQRT2, y = cy + (sx + sy) / Math.SQRT2;
    const radius = Math.max(24, Math.min(40, size * .078)), right = i === 0;
    const top = mobile.matches ? 0 : Math.max(8, Math.min(box.height - labels[i].offsetHeight - 28, y - 70));
    labels[i].style.top = `${top}px`;
    // Measure the visible first name line, not the full fixed-width label box.
    const nameRange = document.createRange();
    nameRange.selectNodeContents(labels[i].querySelector('strong'));
    const nameBox = nameRange.getClientRects()[0] || labels[i].getBoundingClientRect();
    const tx = (right ? nameBox.left - 8 : nameBox.right + 8) - box.left;
    const textY = nameBox.top - box.top + nameBox.height / 2, edge = x + (right ? radius : -radius);
    const path = mobile.matches ? `M${x} ${y - radius} V${labels[i].offsetHeight + 12} H40` : `M${edge} ${y} L${tx + (right ? -18 : 18)} ${textY} H${tx}`;
    const glassId = `phase1-glass-${roundIndex}-${i}`;
    const glint = `M${x - radius * .77} ${y - radius * .38} A${radius * .86} ${radius * .86} 0 0 1 ${x - radius * .18} ${y - radius * .84}`;
    return `<g><defs><linearGradient id="${glassId}" x1="0" y1="0" x2=".7" y2="1"><stop stop-color="white" stop-opacity=".3"/><stop offset=".5" stop-color="white" stop-opacity="0"/><stop offset="1" stop-color="white" stop-opacity=".12"/></linearGradient></defs><circle class="phase1-region-ring" fill="url(#${glassId})" cx="${x}" cy="${y}" r="${radius}"/><circle class="phase1-glass-edge" cx="${x}" cy="${y}" r="${radius - 2.5}"/><path class="phase1-glass-glint" d="${glint}"/><path d="${path}"/><circle class="phase1-leader-dot" cx="${mobile.matches ? x : edge}" cy="${mobile.matches ? y - radius : y}" r="3"/></g>`;
   }).join('');
  });
 };
 const productsResize = new ResizeObserver(positionCallouts); productsResize.observe(products); productsResize.observe(splash);
 const copyResize = new ResizeObserver(positionCallouts); copyResize.observe(stage.querySelector('.opening-copy'));
 positionCallouts(); requestAnimationFrame(positionCallouts);
 const canvas = document.createElement('canvas');
 canvas.className = 'phase1-powder'; canvas.setAttribute('aria-hidden', 'true');
 const ctx = canvas.getContext('2d');
 let source, output, memberships;
 let previous = -1;
 const paint = () => {
  // This is the only timeline input. Reverse scrolling retraces the same states.
  const p = reduced.matches ? 100 : parseFloat(stage.style.getPropertyValue('--mix-progress')) || 0;
  rounds.forEach((round, i) => {
   const start = [5, 35][i], end = [27, 57][i];
   round.element.style.opacity = mobile.matches ? '1' : (smooth(start, start + 5, p) * (1 - smooth(end, end + 6, p))).toFixed(4);
   round.labels.forEach((label, j) => {
    const index = i * 2 + j, a = [5, 27, 43, 59][index], b = [23, 39, 55, 69][index];
    const opacity = mobile.matches ? smooth(a, a + 3, p) * (1 - smooth(b, b + 3, p)) : 1;
    label.style.opacity = opacity.toFixed(4);
    if (round.lines.children[j]) round.lines.children[j].style.opacity = opacity.toFixed(4);
   });
  });
  if (!source || p === previous) return;
  previous = p;
  // Hue regions are illustrative, not ingredient isolates or mass/chemistry encoding.
  const fade = [1 - (1 - 25 / 90) * smooth(55, 75, p), 1 - (1 - 25 / 90) * smooth(14, 35, p), 1 - (1 - 25 / 90) * smooth(45, 69, p), 1 - (1 - 25 / 90) * smooth(27, 63, p)];
  const started = performance.now();
  const roundAlpha = Math.round;
  for (let pixel = 0, offset = 3; offset < source.data.length; pixel++, offset += 4) {
   const m = pixel * 3;
   const teal = memberships[m] / 255, green = memberships[m + 1] / 255, orange = memberships[m + 2] / 255;
   // Partition sums to one. Original RGB is copied once; alpha is never overpainted.
   output.data[offset] = roundAlpha(source.data[offset] * (teal * fade[0] + green * fade[1] + orange * fade[2] + (1 - teal - green - orange) * fade[3]));
  }
  ctx.putImageData(output, 0, 0);
  canvas.dataset.paintMs = (performance.now() - started).toFixed(2);
 };
 const image = new Image();
 image.onload = () => {
  if (!ctx) return;
  canvas.width = image.naturalWidth; canvas.height = image.naturalHeight;
  ctx.drawImage(image, 0, 0);
  source = ctx.getImageData(0, 0, canvas.width, canvas.height);
  output = new ImageData(new Uint8ClampedArray(source.data), canvas.width, canvas.height);
  memberships = new Uint8Array(canvas.width * canvas.height * 3);
  for (let pixel = 0, offset = 0; offset < source.data.length; pixel++, offset += 4) {
   const r = source.data[offset] / 255, g = source.data[offset + 1] / 255, b = source.data[offset + 2] / 255;
   const max = Math.max(r, g, b), min = Math.min(r, g, b), delta = max - min;
   let hue = 0;
   if (delta) hue = ((max === r ? (g - b) / delta : max === g ? (b - r) / delta + 2 : (r - g) / delta + 4) * 60 + 360) % 360;
   const saturation = max ? delta / max : 0;
   const affinity = center => { const distance = Math.min(Math.abs(hue - center), 360 - Math.abs(hue - center)); return Math.exp(-Math.pow(distance / 32, 2)) * saturation; };
   const weights = [affinity(168), affinity(91), affinity(34), Math.max(.12, 1 - saturation)];
   const total = weights.reduce((sum, weight) => sum + weight, 0);
   for (let k = 0; k < 3; k++) memberships[pixel * 3 + k] = Math.floor(weights[k] / total * 255);
  }
  splash.append(canvas); splash.dataset.phase1Ready = 'true'; paint();
 };
 // The baseline pseudo-element remains if decoding fails; the master is never edited.
 image.src = root.dataset.powderSrc;
 const mutation = new MutationObserver(paint); mutation.observe(stage, { attributes: true, attributeFilter: ['style'] });
 reduced.addEventListener('change', () => { previous = -1; paint(); }, {signal:controller.signal});
 mobile.addEventListener('change', () => { positionCallouts(); paint(); }, {signal:controller.signal});
 paint();
 return () => {controller.abort();productsResize.disconnect();copyResize.disconnect();mutation.disconnect();image.onload=null;delete root.dataset.heroInitialized;};
};
